/**
 * React hook to handle errors with snackbar
 */

import { useEffect } from 'react';

import { ErrorData } from '../../../services/types';

import useSnackbar from './useSnackbar';

const useError = (isError: boolean, error: any) => {
  const createSnackbar = useSnackbar();

  useEffect(() => {
    if (isError && error) {
      if (typeof error === 'object' && 'status' in error) {
        createSnackbar((error.data as ErrorData)?.message || 'An error has occurred', 'error');
      } else {
        // If error is a string use it as the message
        if (typeof error === 'string') {
          createSnackbar(error, 'error');
          return;
        }
        createSnackbar(error?.message ?? 'An error has occurred', 'error');
      }
    }
  }, [isError]);
};

export default useError;
